import React from 'react';

const Loader = () => (
    <div style={styles.overlay}>
        <div style={styles.loader}>
            <div style={styles.dot}></div>
            <div style={{ ...styles.dot, animationDelay: '0.2s' }}></div>
            <div style={{ ...styles.dot, animationDelay: '0.4s' }}></div>
        </div>
    </div>
);

const styles = {
    overlay: {
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        background: 'rgba(255,255,255,0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
    },
    loader: {
        display: 'flex',
        gap: '12px',
    },
    dot: {
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        background: 'linear-gradient(135deg, #0070f3 40%, #00c6ff 100%)',
        animation: 'loader-bounce 0.8s infinite alternate',
    }
};

// Keyframes for bounce animation
const styleSheet = `
@keyframes loader-bounce {
    0% { transform: translateY(0); }
    100% { transform: translateY(-18px); }
}
`;

if (typeof window !== 'undefined') {
    const styleTag = document.createElement('style');
    styleTag.innerHTML = styleSheet;
    document.head.appendChild(styleTag);
}

export default Loader;